<template>
  <div :class="$i18n.locale === 'zh' ? 'box cnFamily' : 'box enFamily'">
    <div class="form" style="width: 700px;color: #4d4d4d;">
      <div class="title" style="text-align: center;">{{ $t('confirmationLetter.description') }}</div>
      <div class="name">
        <strong>{{ $t('confirmationLetter.Dear') }}</strong>
        <div style="display: inline-block;border-bottom: 1px solid;padding: 0 10px;" v-if="$i18n.locale === 'zh'">
          {{ form.name || '' }}
          <span>{{ form.sexOriginal }}</span>
        </div>
        <div style="display: inline-block;border-bottom: 1px solid;padding: 0 10px;" v-else>
          <span>{{ form.sexOriginal || '' }}</span>
          {{ form.name }}
        </div>
      </div>
      <div class="subTitle" v-html="$t('confirmationLetter.title')"></div>
      <div class="card">
        <div style="padding: 40px;">
          <div class="cardTitle">{{ $t('confirmationLetter.cardTitle') }}</div>
          <div style="display: flex;">
            <div class="qrcodeCanvasbox">
              <canvas ref="qrcodeCanvas" style="width: 200px; height: 200px;"></canvas>
              <div class="RegistrationCode">{{ $t('confirmationLetter.RegistrationCode') }} {{ form.registerNumber }}
              </div>
            </div>
            <div>
              <div class="item" style="margin-top: 20px;">
                <div class="lable">{{ $t('confirmationLetter.cardName') }}</div>
                <div class="value">{{ form.name }}</div>
              </div>
              <div class="item">
                <div class="lable">{{ $t('confirmationLetter.cardCompany') }}</div>
                <div class="value">{{ form.company }}</div>
              </div>
              <div class="item">
                <div class="lable">{{ $t('confirmationLetter.cardPosition') }}</div>
                <div class="value">{{ form.postOrDept }}</div>
              </div>
              <div class="item">
                <div class="lable">{{ $t('confirmationLetter.cardEmail') }}</div>
                <div class="value">{{ form.email }}</div>
              </div>
            </div>
          </div>
          <div class="tip" style="font-size: 18px;">{{ $t('confirmationLetter.tip') }}</div>
          <el-button style="margin-top: 20px;" @click="modifyData" type="primary">{{ $t('confirmationLetter.btn1')
            }}</el-button>
          <el-button @click="print" type="primary">{{ $t('confirmationLetter.print') }}</el-button>
          <!-- <div style="margin-top: 20px;" v-html="$t('confirmationLetter.qrcode')"></div> -->
        </div>
      </div>
      <div>
        <div style="color: #338dc6;" v-html="$t('confirmationLetter.Preview')"></div>
      </div>
      <div style="margin: 20px 0">
        <div>
          <div class="subTilte" style="margin-top: 20px;margin-bottom: 20px;">{{ $t('confirmationLetter.subTilte2') }}
          </div>
          <div v-html="$t('confirmationLetter.details')"></div>
        </div>
        <div style="margin-top: 20px;" v-if="$i18n.locale != 'zh'">
          <div style="font-weight: bold;font-size: 16px;color:#0070B8;font-family: 'Arial';margin-bottom: 20px;">Contact
            us</div>
          <table>
            <tbody>
              <tr>
              <td valign="top" style="font-size: 16px;color:#4d4d4d;font-family: 'Arial';">
                bauma CHINA Project Team
              </td>
              </tr>
              <tr>
                <td valign="top" style="font-size: 16px;color:#4d4d4d;font-family: 'Arial';">
                  Messe Muenchen Shanghai Co., Ltd.
                </td>
              </tr>
              <tr>
                <td valign="top" style="font-size: 16px;color:#4d4d4d;font-family: 'Arial';">
                  Tel: +86-21 2020 5500 ext. 823/650/615
                </td>
              </tr>
              <tr>
                <td valign="top" style="font-size: 16px;color:#4d4d4d;font-family: 'Arial';">
                  Email: visitor.bc@mm-sh.com
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
      <table v-if="$i18n.locale === 'zh'">
        <tbody>
          <tr>
            <td><img src="../../assets/footer.jpg" style="max-width: 100%; width: 650px;"
                width="650" /></td>
          </tr>
          <tr>
            <td valign="top" style="font-weight: bold;font-size: 16px;color:#0070B8;font-family: '微软雅黑';">
              参观咨询：
            </td>
          </tr>
          <tr>
            <td valign="top" style="font-size: 16px;color:#4d4d4d;font-family: '微软雅黑';">
              电话：021-20205693/631、010-62650570/592
            </td>
          </tr>
          <tr>
            <td valign="top" style="font-size: 16px;color:#4d4d4d;font-family: '微软雅黑';">
              Email：vision@mm-sh.com / visionchina@china-image.cn
            </td>
          </tr>


        </tbody>
      </table>
      <!-- <div style="width: 100%;margin-top: 80px;">
        <img src="../../assets/0914e722cbe010e1051a972cd8c2e6a.jpg">
      </div> -->
    </div>
    <el-dialog :title="$t('confirmationLetter.btn1')" :visible.sync="dialogVisible" width="720px"
      :before-close="() => { dialogVisible = false }">
      <el-form ref="form" :rules="rules" :model="formInline" label-position="top">
        <el-form-item prop="name" :label="$t('preRegistration.form.name.lable')">
          <el-input disabled v-trim v-model="formInline.name"
            :placeholder="$t('preRegistration.form.name.placeholder')"></el-input>
        </el-form-item>
        <el-form-item :prop="$i18n.locale === 'zh' ? 'mobile' : ''" :label="$t('preRegistration.form.mobile.lable')">
          <el-input disabled v-trim v-model="formInline.mobile"
            :placeholder="$t('preRegistration.form.mobile.placeholder')"></el-input>
        </el-form-item>
        <el-form-item :prop="$i18n.locale === 'zh' ? 'email' : ''" :label="$t('preRegistration.form.email.lable')">
          <el-input disabled v-trim v-model="formInline.email"
            :placeholder="$t('preRegistration.form.email.placeholder')"></el-input>
        </el-form-item>
        <el-form-item prop="sex" :label="$t('preRegistration.form.Salutation.lable')">
          <el-radio v-model="formInline.sex" :label="1">{{ $t('preRegistration.form.Salutation.value1') }}</el-radio>
          <el-radio v-model="formInline.sex" :label="2">{{ $t('preRegistration.form.Salutation.value2') }}</el-radio>
        </el-form-item>
        <el-form-item prop="company" :label="$t('preRegistration.form.company.lable')">
          <el-input v-trim v-model="formInline.company"
            :placeholder="$t('preRegistration.form.company.placeholder')"></el-input>
        </el-form-item>
        <el-form-item prop="postOrDept" :label="$t('preRegistration.form.position.lable')">
          <el-input v-trim v-model="formInline.postOrDept"
            :placeholder="$t('preRegistration.form.position.placeholder')"></el-input>
        </el-form-item>
        <el-form-item prop="countryRegion" :label="$t('preRegistration.form.country.lable')">
          <el-select @change="getCountry" clearable filterable v-model="formInline.countryRegion" style="width: 100%;"
            :placeholder="$t('preRegistration.form.country.placeholder')">
            <el-option v-for="(item, index) in country" :key="index" :label="item.name" :value="item.code_en">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="formInline.countryRegion == 'China'">
          <!-- 省份开始 -->
          <el-form-item prop="province" label="省份">
            <el-select @change="getCity" v-model="formInline.province" style="width: 100%;" placeholder="请选择省份">
              <el-option v-for="(item, index) in province" :key="index" :label="item.name"
                :value="item.code_zh"></el-option>
            </el-select>
          </el-form-item>

          <!-- 省份结束 -->
          <!-- 锚 -->
          <!-- 城市开始 -->
          <el-form-item label="城市" prop="city">
            <el-select v-model="formInline.city" style="width: 100%;" placeholder="请选择城市">
              <el-option v-for="(item, index) in city" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <!-- 城市结束 -->
        </template>
        <!-- <template  v-if="$i18n.locale === 'en'">
            <el-form-item label="Passport" prop="passport">
              <el-input v-model="formInline.passport" placeholder="Please enter your passport"></el-input>
            </el-form-item>
          </template> -->
        <el-form-item :label="$t('preRegistration.form.tel.lable')">
          <div style="display: flex;">
            <el-input v-trim :disabled="true" v-model="formInline.countryNumber"></el-input>-
            <el-input v-trim v-model="formInline.areaCode"></el-input>-
            <el-input v-trim v-model="formInline.phoneNumber"></el-input>-
            <el-input v-trim v-model="formInline.extension"></el-input>
          </div>
          <el-link type="danger" :underline="false">{{ $t('preRegistration.form.tel.tip') }}</el-link>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">{{ $t('confirmationLetter.btn2') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import country from '../preRegistration/country.JSON'
import province from '../preRegistration/list.JSON'
import { getInfoCompleted, updateInfo } from '@/tools/api'
import QRCode from 'qrcode';
import { decryptAES } from '@/tools/decryptAES';
export default {
  data() {
    return {
      country: [],
      city: [],
      id: '',
      form: {},
      dialogVisible: false,
      formInline: {
        city: '',
        countryRegion: ''
      },
      rules: {
        sex: { required: true, message: this.$t('preRegistration.rules.sex'), trigger: 'change' },
        company: { required: true, message: this.$t('preRegistration.rules.company'), trigger: 'change' },
        postOrDept: { required: true, message: this.$t('preRegistration.rules.postOrDept'), trigger: 'change' },
        country: { required: true, message: this.$t('preRegistration.rules.country'), trigger: 'change' },
        passport: { required: true, message: this.$t('preRegistration.rules.passport'), trigger: 'change' },
        city: { required: true, message: this.$t('preRegistration.rules.city'), trigger: 'change' },
        province: { required: true, message: this.$t('preRegistration.rules.province'), trigger: 'change' },
        countryRegion: { required: true, message: this.$t('preRegistration.rules.countryRegion'), trigger: 'change' },
        classification: { required: true, message: this.$t('preRegistration.rules.classification'), trigger: 'change' },
      },
    }
  },
  mounted() {
    document.documentElement.scrollTop = 0
    let id = sessionStorage.getItem('id')
    if (id) {
      this.id = id
      this.getInfoCompleted(this.id)
    } else {
      this.$message.error(this.$t('realNameAuthentication.msg1'))
      sessionStorage.clear()
      setTimeout(() => {
        this.$router.replace({ path: '/index' })
      }, 3000)
    }
  },

  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          updateInfo(this.formInline).then(res => {
            if (res.code == 0) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.getInfoCompleted(this.id)
              this.dialogVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    },
    getCountry(e) {
      this.formInline.city = ''
      this.formInline.province = ''
      this.country.map(item => {
        if (item.code_zh == e || item.code_en == e) {
          this.formInline.countryNumber = item.phone_code
        }
      })
    },
    modifyData() {
      this.dialogVisible = true
      this.country = country
      this.province = province
      this.formInline = {
        sex: this.form.sex,
        company: this.form.company,
        postOrDept: this.form.postOrDept,
        countryRegion: this.form.countryRegion,
        province: this.form.province,
        city: this.form.city,
        countryNumber: this.form.countryNumber,
        areaCode: this.form.areaCode,
        extension: this.form.extension,
        phoneNumber: this.form.phoneNumber,
        id: this.id,
        name: this.form.name,
        mobile: this.form.mobile,
        email: this.form.email
      }
      this.$forceUpdate()
    },
    go() {
      // let src = this.$i18n.locale == 'zh' ? 'https://www.b-china.cn/travel-stay/getting-there/' : 'https://www.b-china.cn/visitorsen/notice'
      // window.open(src)
    },
    go2() {
      let src = this.$i18n.locale == 'zh' ? 'https://bauma-china.com/trade-fair/travel-stay/getting-there/index.html' : 'https://bauma-china.com/en/trade-fair/plan-your-visit/travel-journey/'
      window.open(src)
    },
    getInfoCompleted(id) {
      getInfoCompleted({ id }).then(res => {
        if (res.code == 0) {
          this.form = decryptAES(res.data)
          this.createdQrcode(this.form.registerNumber)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    createdQrcode(text) {
      QRCode.toCanvas(this.$refs.qrcodeCanvas, text, { width: 200 }, (err) => {
        console.log(err)
      });
    },
    getCity(e, v) {
      this.province.map(item => {
        if (item.name == e) {
          this.city = item.cities
        }
      })
      this.formInline.city = ''
    },
    print() {
      window.print()
    }
  }
}
</script>
<style>
.cnFamily {
  font-family: '微软雅黑'
}

.enFamily {
  font-family: 'Arial'
}

.subTitle {
  margin-top: 20px;
}

.subTitle>div {
  margin-bottom: 10px;
}

.card {
  margin-top: 20px;
  background-color: #f5f5f5;
  border-radius: 10px;
}

.cardTitle {
  font-size: 16px;
  color: #0070B8;
  font-weight: bold;
  margin-bottom: 20px;
}

.item {
  display: flex;
  line-height: 40px;
}

.lable {
  min-width: 120px;
  color: #4d4d4d;
  ;
  font-weight: bold;
  font-size: 16px;
}

.value {
  font-size: 16px;
  color: #4d4d4d;
}

.qrcodeCanvasbox {
  margin-right: 40px;
}

.RegistrationCode {
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
}

.tip {
  margin-top: 20px;
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.subTilte {
  color: #0070B8;
  font-size: 16px;
  font-weight: bold;
}

.subValue {
  font-size: 14px;
  margin-top: 10px;
}

.li {
  font-size: 14px;
}
</style>